import '../../../assets/styles/ErrorMessage.css'

import React from 'react'

import { Link } from 'react-router-dom'
import { useBrand } from '../../../contexts/BrandContext'
import { useAudioVideo } from '../../../hooks/storeHooks/useSessionState'

export const ErrorMessage: React.FC = () => {
  const { webRTCStatus } = useAudioVideo()
  const brand = useBrand()

  const handleReload = () => window.location.reload()

  return (
    <div className="tc-mentor-waiting-wrapper">
      <div className="tc-mentor-waiting-container">
        <div className="tc-mentor-waiting-logo flex align-middle items-center !mb-8">
          <img src={brand.logo} className="h-[26px]" alt="logo" />
        </div>
        <div className="tc-mentor-waiting-desc">{webRTCStatus?.message}</div>
        <div className="tc-mentor-waiting-buttons-container">
          {webRTCStatus?.btnType === 'home' ? (
            <Link to="/" className="btn btn-secondary mt-4 ">
              Go Home
            </Link>
          ) : (
            <button onClick={handleReload} className="btn btn-secondary mt-4 ">
              Try Again
            </button>
          )}
        </div>
        <div className="tc-mentor-waiting-log !text-black">
          {webRTCStatus?.reason}
        </div>
      </div>
    </div>
  )
}
